<template>
  <div v-if="place">
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <!-- Name -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model="place.Name"
              label="Name"
              placeholder="Name"
              required
              outlined
              hide-details
              disabled
            ></v-text-field>
          </v-col>
          <!-- Address -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model="place.AddressText"
              label="Address"
              required
              outlined
              hide-details
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isGlobalAdmin || user.canEditAvailabilityTable">
          <v-col cols="12">
            <v-expansion-panels v-model="availabilityTableExpansionPanel">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.EDIT_WHITELISTS.AVAILABILITY_AND_PRICING'
                    )
                  }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="elevation-0">
                    <v-card-text class="pa-0">
                      <v-col cols="2" class="pa-0">
                        <v-text-field
                          v-model.number="limit24h"
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.AVAILABILITY_TABLE.24H_COST'
                            )
                          "
                          type="number"
                          outlined
                          hide-details
                          :suffix="regionCurrencies[region]"
                          :disabled="!isGlobalAdmin"
                        />
                      </v-col>
                      <v-col cols="12">
                        <day-editor
                          v-for="weekday in weekdays"
                          :key="weekday.original"
                          :weekday="weekday"
                          :currency="regionCurrencies[region]"
                          use-for="place"
                          :disable-prices="!isGlobalAdmin"
                        />
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-btn
          style="position: fixed; right: 36px; bottom: 36px; z-index: 999;"
          color="primary"
          class="secondary--text"
          :disabled="!isGlobalAdmin && !user.canEditAvailabilityTable"
          @click="save()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DayEditor from '@/components/DayEditor'

export default {
  name: 'Place',
  components: {
    DayEditor
  },
  props: {
    id: String
  },
  data: () => ({
    valid: false,
    availabilityTableExpansionPanel: 0,
    weekdays: [
      { i18n: 'MONDAY', original: 'Monday' },
      { i18n: 'TUESDAY', original: 'Tuesday' },
      { i18n: 'WEDNESDAY', original: 'Wednesday' },
      { i18n: 'THURSDAY', original: 'Thursday' },
      { i18n: 'FRIDAY', original: 'Friday' },
      { i18n: 'SATURDAY', original: 'Saturday' },
      { i18n: 'SUNDAY', original: 'Sunday' }
    ],
    regionCurrencies: {
      AUS: 'AUD',
      BGR: 'BGN',
      CAN: 'CAD',
      CHE: 'CHF',
      CZE: 'CZK',
      DNK: 'DKK',
      EST: 'EUR',
      FIN: 'EUR',
      GBR: 'GBP',
      HUN: 'HUF',
      IND: 'INR',
      ISL: 'ISK',
      LTU: 'EUR',
      LVA: 'EUR',
      POL: 'PLN',
      RUS: 'RUB',
      SWE: 'SEK',
      SGP: 'SGD',
      UKR: 'UAH',
      USA: 'USD'
    }
  }),
  computed: {
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('places', ['place']),
    region: {
      get() {
        return this.place.Region
      },
      set(value) {
        this.setPlaceValue({
          key: 'Region',
          value
        })
      }
    },
    limit24h: {
      get() {
        return this.place.DiscountPlan.Limit24h
      },
      set(value) {
        this.setPlaceDiscountPlanValue({
          key: 'Limit24h',
          value
        })
      }
    }
  },
  created() {
    if ((this.place && this.place.id) || this.id) {
      this.getPlace(this.id)
    }
  },
  methods: {
    ...mapActions('places', ['getPlace', 'postPlace']),
    ...mapMutations('places', ['setPlaceValue', 'setPlaceDiscountPlanValue']),
    save() {
      this.postPlace()
    }
  }
}
</script>
